<div class="modal fade" bsModal #staticModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-md">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Package Details</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hidePackageDetailsWindow()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 200px;overflow: auto;padding:15px;padding-top:0px;"
        *ngIf="selectedSubscribedPackage!=null">
        <table class="table table-borderless" style="margin-bottom: 0px;">
          <tr>
            <td>Package name :&nbsp; {{selectedSubscribedPackage.pkgName}}
              <br />
              Unit price :&nbsp; {{selectedSubscribedPackage.currency === 'INR' ? '₹' : (selectedSubscribedPackage.currency === 'USD' ? '$' : null)}}
              {{selectedSubscribedPackage.price * selectedSubscribedPackage.quantity | number:'.2'}}
              <br />
              Validity :&nbsp; {{selectedSubscribedPackage.validity}} days<span style="float:right;">Expiry
                Date :
                <!--{{selectedSubscribedPackage.expiry | date:'dd/MMM/yyyy hh:mm a'}}-->
                {{selectedSubscribedPackage.expiry | date:customDateFormat}}</span>
            </td>
          </tr>
        </table>
        <table class="table table-borderless table-striped">
          <tr>
            <!-- <td>#</td> -->
            <td>Service Name</td>
            <td>Units</td>
            <td>Units Used</td>
            <td>Units Remaining</td>
          </tr>
          <tr ng-if="tempPackage.fundusUnit>0">
            <!-- <td>1</td> -->
            <td>Fundus</td>
            <td>{{selectedSubscribedPackage.fundusUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.fundusUnitAvailed-selectedSubscribedPackage.fundusUnit}} units
            </td>
            <td>{{selectedSubscribedPackage.fundusUnit}} units</td>
          </tr>
          <!-- <tr ng-if="tempPackage.fundusAutonomousUnit>0">
            <td>Fundus Autonomous</td>
            <td>{{selectedSubscribedPackage.fundusAutonomousUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.fundusAutonomousUnitAvailed-selectedSubscribedPackage.fundusAutonomousUnit}}
              units
            </td>
            <td>{{selectedSubscribedPackage.fundusAutonomousUnit}} units</td>
          </tr> -->
          <tr ng-if="tempPackage.refractionUnit>0">
            <td>Refraction</td>
            <td>{{selectedSubscribedPackage.refractionUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.refractionUnitAvailed-selectedSubscribedPackage.refractionUnit}}
              units
            </td>
            <td>{{selectedSubscribedPackage.refractionUnit}} units</td>
          </tr>
          <tr ng-if="tempPackage.teleRefractionUnit>0">
            <td>Telerefraction</td>
            <td>{{selectedSubscribedPackage.teleRefractionUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.teleRefractionUnitAvailed-selectedSubscribedPackage.teleRefractionUnit}}
              units
            </td>
            <td>{{selectedSubscribedPackage.teleRefractionUnit}} units</td>
          </tr>
          <tr ng-if="tempPackage.aiUnit>0">
            <!-- <td>1</td> -->
            <td>AI Units</td>
            <td>{{ selectedSubscribedPackage.aiUnitAvailed || 0 }} units</td>
            <td>{{selectedSubscribedPackage.aiUnitAvailed-selectedSubscribedPackage.aiUnit}} units
            </td>
            <td>{{selectedSubscribedPackage.aiUnit}} units</td>
          </tr>
          <!-- <tr ng-if="tempPackage.spectacleBasicUnit>0">
            <td>Spectacle Basic</td>
            <td>{{selectedSubscribedPackage.spectacleBasicUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.spectacleBasicUnitAvailed-selectedSubscribedPackage.spectacleBasicUnit}}
              units
            </td>
            <td>{{selectedSubscribedPackage.spectacleBasicUnit}} units</td>
          </tr>
          <tr ng-if="tempPackage.spectacleAdvancedUnit>0">
            <td>Spectacle Advanced</td>
            <td>{{selectedSubscribedPackage.spectacleAdvancedUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.spectacleAdvancedUnitAvailed-selectedSubscribedPackage.fundusUnit}}
              units
            </td>
            <td>{{selectedSubscribedPackage.spectacleAdvancedUnit}} units</td>
          </tr>
          <tr ng-if="tempPackage.referralUnit>0">
            <td>Referral</td>
            <td>{{selectedSubscribedPackage.referralUnitAvailed}} units</td>
            <td>{{selectedSubscribedPackage.referralUnitAvailed-selectedSubscribedPackage.referralUnit}}
              units
            </td>
            <td>{{selectedSubscribedPackage.referralUnit}} units</td>
          </tr> -->
        </table>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" (click)="hidePackageDetailsWindow()">Close</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #refundModal="bs-modal" bsModal [config]="{backdrop: 'static'}" tabindex="-1" role="dialog"
  aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Refund Info</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideRefundDetailsWindow()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 200px;overflow: auto;padding:15px;padding-top:0px;margin-top:15px;">
        <textarea name="refundcomments" rows="3" [(ngModel)]="refundComments" #refundcomments="ngModel"
          id="refundComments" class="form-control" placeholder="Enter refund comments here..." required
          style="margin-bottom: 15px;resize: none; border: 1px solid #e1e1e1;padding: 15px;" class="form-control">
        </textarea>
        <p-table [value]="selectedPackageForRefund.subsriptionPkg"
          [paginator]="selectedPackageForRefund.subsriptionPkg!=null && selectedPackageForRefund.subsriptionPkg.length>10"
          [rows]="10" #dt>
          <ng-template pTemplate="header">
            <tr>
              <th>Select Package
              </th>
              <th [pSortableColumn]="'pkgName'">Package Name
                <p-sortIcon [field]="'pkgName'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'currentStatus'">Status
                <p-sortIcon [field]="'currentStatus'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'quantity'">Qty
                <p-sortIcon [field]="'quantity'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'price'">Price
                <p-sortIcon [field]="'price'"></p-sortIcon>
              </th>
            </tr>
            <tr
              *ngIf="selectedPackageForRefund.subsriptionPkg==null || selectedPackageForRefund.subsriptionPkg.length==0"
              style="border-left: 1px solid #CCC;border-right: 1px solid #CCC;border-bottom: 1px solid #CCC;">
              <td colspan="5">
                <div style="padding: 5px;text-align: center;">
                  No record found
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-package let-i="rowIndex">
            <tr style="cursor: pointer;">
              <td>
                <div class="chiller_cb" *ngIf="package.currentStatus=='PACKAGE_SUBSCRIBED'">
                  <input [(ngModel)]="package.isReturn" #{{package.id}}="ngModel" (ngModelChange)="updateRefundAmount()"
                    [attr.name]="package.id" [attr.id]="package.id" type="checkbox" />
                  <label style="font-weight: normal;" for={{package.id}}>&nbsp;</label>
                  <span></span>
                </div>
              </td>
              <td>{{package.pkgName}}</td>
              <td>
                <span class="badge badge-info" *ngIf="package.currentStatus=='PACKAGE_SUBSCRIPTION_INITIATED'"
                  style="border-radius: 4px;font-weight: normal;">Payment Initiated</span>
                <span class="badge badge-info" *ngIf="package.currentStatus=='PACKAGE_SUBSCRIBED'"
                  style="border-radius: 4px;font-weight: normal;">Yet to use</span>
                <span class="badge badge-success" *ngIf="package.currentStatus=='PACKAGE_IN_USE'"
                  style="border-radius: 4px;font-weight: normal;">In Use</span>
                <span class="badge badge-warning" *ngIf="package.currentStatus=='PACKAGE_QUOTA_EXCEEDED'"
                  style="border-radius: 4px;font-weight: normal;">Quota Exceeded</span>
                <span class="badge badge-danger" *ngIf="package.currentStatus=='PACKAGE_EXPIRED'"
                  style="border-radius: 4px;font-weight: normal;">Expired</span>
              </td>
              <td>{{package.quantity}}</td>
              <td>{{package.currency === 'INR' ? '₹' : (package.currency === 'USD' ? '$' : null)}}&nbsp;{{package.price |  number : '.2-2'}}</td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="modal-footer">
        <span style="float: left;font-size: 20px;"
          *ngIf="amounttoRefund>0 && selectedSubscriptionsToRefund>0">{{selectedSubscriptionsToRefund}} Packages
          selected to refund
          &nbsp;<span style="color: darkgreen;">{{selectedPackageForRefund.currency === 'INR' ? '₹' : (selectedPackageForRefund.currency === 'USD' ? '$' : null)}};&nbsp;{{amounttoRefund | number : '.2-2'}}</span></span>
        <button class="btn btn-sm btn-danger" (click)="hideRefundDetailsWindow()">Close</button>
        <button class="btn btn-sm btn-warning" *ngIf="amounttoRefund>0 && selectedSubscriptionsToRefund>0"
          (click)="refundAmount()">Refund</button>
      </div>
    </div>
  </div>
</div>

<div class="modal fade" #refundHistoryModal="bs-modal" bsModal [config]="{backdrop: 'static'}" tabindex="-1"
  role="dialog" aria-labelledby="dialog-static-name">
  <div class="modal-dialog modal-lg">
    <div class="modal-content">
      <div class="modal-header">
        <h4 id="dialog-events-name" class="modal-title pull-left">Refund History</h4>
        <button type="button" class="close pull-right" aria-label="Close" (click)="hideRefundHistoryWindow()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body" style="max-height: 200px;overflow: auto;padding:15px;padding-top:0px;margin-top:15px;">
        <p-table [value]="refundHistory" [paginator]="refundHistory!=null && refundHistory.length>10" [rows]="10" #dt>
          <ng-template pTemplate="header">
            <tr>
              <th>
                #
              </th>
              <th [pSortableColumn]="'transactionId'">Transaction Id
                <p-sortIcon [field]="'transactionId'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'refundAmount'">Amount
                <p-sortIcon [field]="'refundAmount'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'comments'">Comments
                <p-sortIcon [field]="'comments'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'refundCreatedBy'">Initiated By
                <p-sortIcon [field]="'refundCreatedBy'"></p-sortIcon>
              </th>
              <th [pSortableColumn]="'payuRefundStatus'">Status
                <p-sortIcon [field]="'payuRefundStatus'"></p-sortIcon>
              </th>
            </tr>
            <tr *ngIf="refundHistory==null || refundHistory.length==0"
              style="border-left: 1px solid #CCC;border-right: 1px solid #CCC;border-bottom: 1px solid #CCC;">
              <td colspan="6">
                <div style="padding: 5px;text-align: center;">
                  No record found
                </div>
              </td>
            </tr>
          </ng-template>
          <ng-template pTemplate="body" let-refund let-i="rowIndex">
            <tr>
              <td>{{i+1}}</td>
              <td>{{refund.transactionId}}</td>
              <td>{{refund.currency === 'INR' ? '₹' : (refund.currency === 'USD' ? '$' : null)}}&nbsp;{{refund.refundAmount |  number : '.2-2'}}
              </td>
              <td>{{refund.comments}}</td>
              <td>{{refund.refundCreatedBy}}</td>
              <td>
                <span *ngIf="refund.payuRefundStatus == 'FULL REFUNDED'"
                  class="badge badge-info">{{refund.payuRefundStatus}}</span>
                <span *ngIf="refund.payuRefundStatus == 'REFUND IN PROGRESS'"
                  class="badge badge-warning">{{refund.payuRefundStatus}}</span>
                <span *ngIf="refund.payuRefundStatus == 'SETTLEMENT IN PROGRESS'"
                  class="badge badge-success">{{refund.payuRefundStatus}}</span>
              </td>
            </tr>
          </ng-template>
        </p-table>
      </div>
      <div class="modal-footer">
        <button class="btn btn-sm btn-danger" (click)="hideRefundHistoryWindow()">Close</button>
      </div>
    </div>
  </div>
</div>


<section class="box">
  <div class="tile-progress bg-white text-left">
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
        <label>Select Date Range</label>
        <ngx-mat-drp (selectedDateRangeChanged)="updateRange($event)" [options]="options" #dateRangePicker>
        </ngx-mat-drp>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3">
        <label>Select Application</label>
        <ng-select [items]="applications" name="applications" placeholder="Select Application" 
        bindLabel="name" [clearable]="true" [searchable]="true" bindValue="id" [(ngModel)]="applicationId" (change)="changeApplication()">
        </ng-select>
      </div>
      <!-- <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngIf="applicationId=='SPECTACLE'">
        <label>Select Spectacle Vendor</label>
        <ng-select [items]="spectacleVendorProviders" name="spectacleVendorProviders"  placeholder="Select Vendor Provider" 
        bindLabel="providerName" [clearable]="true" [searchable]="true" bindValue="providerId" [(ngModel)]="selectedSpectacleVendorProviderId" (change)="getTransactionHistory()">
        </ng-select>
      </div> -->
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngIf="applicationId=='DHP' || applicationId=='APPOINTMENT_BOOKING'">
        <label>Select Account</label>
        <ng-select [items]="accounts" (change)="getScreeningCentersByAccountID()" name="accounts"
          placeholder="Select account" bindLabel="accountName" [clearable]="true" [searchable]="true" bindValue="accountId"
          [(ngModel)]="accountId">
        </ng-select>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-3" *ngIf="accountId!=null && accountId>0">
        <label>Select Screening Center</label>
        <ng-select [items]="screeningCenters" (change)="getTransactions()" name="screeingcenters"
          placeholder="Select screening center" bindLabel="orgName" [clearable]="true" [searchable]="true"
          bindValue="orgId" [(ngModel)]="orgId">
        </ng-select>
      </div>
    </div>
    <div class="row">
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4">
        <label>Search by transaction id</label>
        <input type="text" name="bytransactionid" (keyup)="filterTransactionByTransactionId($event)"
          id="bytransactionid" minlength="3" #bytransactionid="ngModel" [(ngModel)]="transactionIdSearch"
          class="form-control" placeholder="Enter transaction id to search transaction" />
        <div class="danger-text" *ngIf="bytransactionid.errors?.minlength  && bytransactionid.dirty">
          Transaction id must be at least 3 characters long.
        </div>
      </div>
      <div class="col-xs-12 col-sm-6 col-md-4 col-lg-4" *ngIf="applicationId!='APPOINTMENT_BOOKING'">
        <label>Search by user name/email</label>
        <input type="text" name="byusername" minlength="3" (keyup)="filterTransactionByUserName(0)"
          id="byusername" #byusername="ngModel" [(ngModel)]="userSearch" class="form-control"
          placeholder="Enter username/email to search transaction" />
        <div class="danger-text" *ngIf="byusername.errors?.minlength && byusername.dirty">
          User name/email must be at least 3 characters long.
        </div>
      </div>
    </div>
  </div>
  <div>
    <div class="card-header">
      Payments completed
      <!-- <span style="float:right;">{{filteredTime.startDate | date:'MMM d, y'}} -
        {{filteredTime.endDate | date:'MMM d, y'}}</span> -->
    </div>
    <ul style="list-style-type: none;margin: 0;padding: 0;overflow: hidden;width:100%;border-bottom: 1px solid #CCC;padding-top: 15px;
    background: #FFF;
    margin-bottom: 15px;">
      <li id="all" (click)="filterByTransactionStatus('all')"
        style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
        All Transactions</li>
      <li id="success" (click)="filterByTransactionStatus('successful')"
        style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
        Successful Transactions</li>
      <li id="failure" (click)="filterByTransactionStatus('failed')"
        style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
        Failed Transactions</li>
      <li id="initiated" (click)="filterByTransactionStatus('initiated')"
        style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
        Initiated Transactions</li>
      <li id="refunded" (click)="filterByTransactionStatus('refunded')"
        style="cursor: pointer; float: left;display: block;text-align: center;padding: 5px 20px;text-decoration: none;">
        Refunded Transactions</li>
    </ul>
    <div class="col-xs-12 text-center" *ngIf="transactionHistory==null || transactionHistory.length==0"
      style="background: #FFF;padding: 10px;margin-bottom: 20px;">
      No record found
    </div>

    <p-table [value]="transactionHistory" [lazy]="true" (onLazyLoad)="paginatedTransactions($event)" [paginator]="transactionHistory!=null && transactionHistory.length>0 && totalRecords>recordsPerPage" [rows]="recordsPerPage" [totalRecords]="totalRecords" class="no-cell-padding">
      <ng-template pTemplate="body" let-transaction let-i="rowIndex">
      <tr><td>
        <div class="card-body" style="background: #FFF;padding-top: 10px;margin-top: 20px;padding-left: 20px;padding-right: 20px;">
          <div style="border-color: #FFF;">
            <div *ngIf="transactionHistory!=null && transactionHistory.length>0">
              <table class="table transaction-header"
                [ngClass]="{'border-bottom-success' : transaction.paymentStatus =='success', 'border-bottom-danger' : transaction.paymentStatus=='failure', 'border-bottom-info' : transaction.paymentStatus=='INITIATED'}"
                style="margin-bottom: 0px !important">
                <tr>
                  <td>Transaction Id :&nbsp;{{transaction.transactionId}}</td>
                  <td *ngIf="transaction.paymentStatus!='INITIATED'" style="text-align: right;">Amount Payable :&nbsp;
                    {{transaction.currency === 'INR' ? '₹' : (transaction.currency === 'USD' ? '$' : null)}} {{transaction.price |  number : '.2-2'}}
                  </td>
                </tr>
                <tr>
                  <td>Transaction Date & Time :&nbsp;<!--{{transaction.paymentTime | date:'dd/MMM/yyyy hh:mm a'}}-->
                  {{transaction.paymentTime | date:customDateFormat}}</td>
                  <td style="text-align: right;">Amount <span *ngIf="transaction.paymentStatus!='INITIATED'">Paid</span>
                    :&nbsp;{{transaction.currency === 'INR' ? '₹' : (transaction.currency === 'USD' ? '$' : null)}}
                    {{transaction.amountPaid |  number : '.2-2'}}
                  </td>
                </tr>
                <tr>
                  <td>Transaction Status :<span *ngIf="transaction.refundMode==null">&nbsp;<span class="badge badge-success"
                        *ngIf="transaction.paymentStatus=='success'"
                        style="border-radius: 4px;font-weight: normal;">Success</span>
                      <span class="badge badge-danger" *ngIf="transaction.paymentStatus=='failure'"
                        style="border-radius: 4px;font-weight: normal;">Failure</span>
                      <span class="badge badge-info" *ngIf="transaction.paymentStatus=='INITIATED'"
                        style="border-radius: 4px;font-weight: normal;">Initiated</span>&nbsp;
                    
                    <span style="margin-left: 10px;">
                      <span class="badge badge-warning" *ngIf="transaction.isOffline"
                        style="border-radius: 4px;font-weight: normal;">Offline</span>
                      <span class="" *ngIf="!transaction.isOffline"
                        style="border-radius: 4px;font-weight: normal;color:blue;">Online</span>
                    </span>
                    <span *ngIf="transaction.refundMode!=null && transaction.isOffline" style="margin-left: 10px;">
                      <span class="badge badge-warning" *ngIf="transaction.refundMode=='PARTIAL'"
                        style="border-radius: 4px;font-weight: normal;">Partial Refund</span>
                      <span class="badge badge-danger" *ngIf="transaction.refundMode=='FULL'"
                        style="border-radius: 4px;font-weight: normal;">Full Refund</span>

                      <span class="badge badge-warning" *ngIf="transaction.refundMode!=null"
                        (click)="getRefundHistoryByTransactionId(transaction.transactionId)"
                        style="font-weight: normal;cursor: pointer;margin-left: 15px;border-radius: 0px;">View
                        refund history</span>
                    </span>
                    <span class="badge badge-warning"
                      *ngIf="!transaction.isOffline && transaction.paymentStatus=='success' && transaction.refundMode!='FULL' && transaction.eligibleForRefundAction"
                      (click)="initiateRefund(transaction)"
                      style="font-weight: normal;cursor: pointer;margin-left: 15px;border-radius: 0px;">Initiate
                      Refund</span>
                      <span class="badge badge-info zoom" data-toggle="tooltip" title="Refresh" 
                      *ngIf="(transaction.paymentStatus!='success') || (transaction.paymentStatus=='success' && findValueInJsonArray(transaction.subsriptionPkg,'PACKAGE_SUBSCRIPTION_INITIATED'))"
                      style="margin-left: 20px;border-radius: 0px; font-weight: normal; cursor: pointer;background-color: #3aadad !important;padding: 4px 4px;"
                      (click)="syncPaymentStatus(transaction)"><i class="fa fa-refresh"></i>  Refresh</span>
              </span>
                  </td>
                  <td style="text-align: right;"><span *ngIf="transaction.paymentStatus=='INITIATED'">Initiated
                      by</span><span *ngIf="transaction.paymentStatus!='INITIATED'">Purchased by</span> :&nbsp;
                    {{transaction.createdBy}}</td>
                </tr>
                <tr >
                  <td style="padding-bottom:10px;">
                      Payment Gateway :&nbsp;
                      <span *ngIf="transaction.mercantile!=null && (transaction.mercantile.toUpperCase()=='RAZORPAY' || transaction.mercantile.toUpperCase()=='PAYUMONEY');else else_content">
                      <span class="badge" style="border-radius: 4px;background:#03299c;font-style: italic;font-weight: normal;" *ngIf="transaction.mercantile.toUpperCase()=='RAZORPAY'">{{transaction.mercantile}}</span>
                      <span class="badge" style="border-radius: 4px;background:#F4A460;font-style: italic;font-weight: normal;" *ngIf="transaction.mercantile.toUpperCase()=='PAYUMONEY'">{{transaction.mercantile}}</span>
                      </span>
                      <ng-template #else_content>NA</ng-template>
                  </td>
                  <td style="text-align: right;">
                    Role :&nbsp; {{transaction.rechargeDoneByUserRole}}
                  </td>
                </tr>
              </table>
            </div>
            <div style="padding-top: 5px;padding-bottom: 5px;">
              <table class="table table-borderless" style="margin-bottom: 0px !important;">
                <tr *ngFor="let package of transaction.subsriptionPkg">
                  <td style="border:none; padding-top: 5px;">Package name :&nbsp; {{package.pkgName}} <span style="margin-left:10px;">
                      <span *ngIf="package.currentStatus=='PACKAGE_SUBSCRIPTION_INITIATED'" style="color:#26c6da;">Payment
                        Initiated</span>
                      <span *ngIf="package.currentStatus=='PACKAGE_SUBSCRIBED'" style="color:#26c6da;">[Yet to use]</span>
                      <span *ngIf="package.currentStatus=='PACKAGE_IN_USE'" style="color:#46be8a;">[In Use]</span>
                      <span *ngIf="package.currentStatus=='PACKAGE_QUOTA_EXCEEDED'" style="color:darkorange;">[Quota
                        Exceeded]</span>
                      <span *ngIf="package.currentStatus=='PACKAGE_EXPIRED'" style="color:#ef5350;">[Expired]</span>
                      <span *ngIf="package.currentStatus=='PAYMENT REFUNDED'" style="color:darkorange;">[Refund
                        Processed]</span>
                    </span>
                    <br />
                    Unit price :&nbsp;{{package.currency === 'INR' ? '₹' : (package.currency === 'USD' ? '$' : null)}} {{package.price  | number : '.2-2'}}
                    <br />
                    Quantity :&nbsp; {{package.quantity}}
                  </td>
                  <td style="border:none;">
                    <button class="btn btn-xs btn-primary pull-right" style="padding: 5px !important;"
                      (click)="showSubscribedPackageDetailsWindow(package)">View package details</button>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </td></tr>
      </ng-template>
    </p-table>

  </div>
</section>